// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Common = require("../utils/Common.res.js");
var Core__Math = require("@rescript/core/src/Core__Math.res.js");
var MM_context = require("../mm-utils/MM_context.res.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var MM_wrk_client = require("../worker/MM_wrk_client.res.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.res.js");
var MM_react_common = require("../ui-utils/MM_react_common.res.js");
var MM_substitution = require("../mm-utils/MM_substitution.res.js");
var Expln_React_Modal = require("../../rescript-utils/main/react-components/Expln_React_Modal.res.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.res.js");
var Expln_React_common = require("../../rescript-utils/main/Expln_React_common.res.js");
var MM_wrk_search_asrt = require("../worker/MM_wrk_search_asrt.res.js");
var Paper = require("@mui/material/Paper").default;
var Expln_utils_promise = require("../../rescript-utils/main/Expln_utils_promise.res.js");
var JsxPPXReactSupportU = require("rescript/lib/js/jsxPPXReactSupportU.js");
var Button = require("@mui/material/Button").default;
var Select = require("@mui/material/Select").default;
var MM_wrk_pattern_search = require("../worker/MM_wrk_pattern_search.res.js");
var Checkbox = require("@mui/material/Checkbox").default;
var MenuItem = require("@mui/material/MenuItem").default;
var MM_use_highlight_color = require("./MM_use_highlight_color.res.js");
var TextField = require("@mui/material/TextField").default;
var MM_cmp_pe_frame_summary = require("../explorer/MM_cmp_pe_frame_summary.res.js");
var InputLabel = require("@mui/material/InputLabel").default;
var Pagination = require("@mui/material/Pagination").default;
var FormControl = require("@mui/material/FormControl").default;

function makeInitialState(frms, initialTyp) {
  if (MM_substitution.frmsSize(frms) === 0) {
    throw {
          RE_EXN_ID: Common.MmException,
          _1: {
            msg: "Cannot search assertions when frms are empty."
          },
          Error: new Error()
        };
  }
  var allTypes = MM_substitution.frmsGetAllTypes(frms);
  return {
          label: "",
          allTypes: allTypes,
          typ: Belt_Option.getWithDefault(Belt_Option.map(initialTyp, (function (iniTyp) {
                      if (allTypes.includes(iniTyp)) {
                        return iniTyp;
                      } else {
                        return allTypes[0];
                      }
                    })), allTypes[0]),
          patternStr: "",
          patternErr: undefined,
          results: undefined,
          resultsPerPage: 10,
          resultsMaxPage: 1,
          resultsPage: 1,
          checkedResultsIdx: []
        };
}

function setResults(st, results) {
  var maxPage = Core__Math.Int.ceil(results.length / st.resultsPerPage);
  return {
          label: st.label,
          allTypes: st.allTypes,
          typ: st.typ,
          patternStr: st.patternStr,
          patternErr: st.patternErr,
          results: results,
          resultsPerPage: st.resultsPerPage,
          resultsMaxPage: maxPage,
          resultsPage: 1,
          checkedResultsIdx: []
        };
}

function setPage(st, page) {
  return {
          label: st.label,
          allTypes: st.allTypes,
          typ: st.typ,
          patternStr: st.patternStr,
          patternErr: st.patternErr,
          results: st.results,
          resultsPerPage: st.resultsPerPage,
          resultsMaxPage: st.resultsMaxPage,
          resultsPage: Math.max(0, Math.min(st.resultsMaxPage, page)),
          checkedResultsIdx: st.checkedResultsIdx
        };
}

function setLabel(st, label) {
  return {
          label: label,
          allTypes: st.allTypes,
          typ: st.typ,
          patternStr: st.patternStr,
          patternErr: st.patternErr,
          results: st.results,
          resultsPerPage: st.resultsPerPage,
          resultsMaxPage: st.resultsMaxPage,
          resultsPage: st.resultsPage,
          checkedResultsIdx: st.checkedResultsIdx
        };
}

function setType(st, typ) {
  return {
          label: st.label,
          allTypes: st.allTypes,
          typ: typ,
          patternStr: st.patternStr,
          patternErr: st.patternErr,
          results: st.results,
          resultsPerPage: st.resultsPerPage,
          resultsMaxPage: st.resultsMaxPage,
          resultsPage: st.resultsPage,
          checkedResultsIdx: st.checkedResultsIdx
        };
}

function setPatternStr(st, patternStr) {
  return {
          label: st.label,
          allTypes: st.allTypes,
          typ: st.typ,
          patternStr: patternStr,
          patternErr: st.patternErr,
          results: st.results,
          resultsPerPage: st.resultsPerPage,
          resultsMaxPage: st.resultsMaxPage,
          resultsPage: st.resultsPage,
          checkedResultsIdx: st.checkedResultsIdx
        };
}

function setPatternErr(st, patternErr) {
  return {
          label: st.label,
          allTypes: st.allTypes,
          typ: st.typ,
          patternStr: st.patternStr,
          patternErr: patternErr,
          results: st.results,
          resultsPerPage: st.resultsPerPage,
          resultsMaxPage: st.resultsMaxPage,
          resultsPage: st.resultsPage,
          checkedResultsIdx: st.checkedResultsIdx
        };
}

function toggleResultChecked(st, idx) {
  if (st.checkedResultsIdx.includes(idx)) {
    return {
            label: st.label,
            allTypes: st.allTypes,
            typ: st.typ,
            patternStr: st.patternStr,
            patternErr: st.patternErr,
            results: st.results,
            resultsPerPage: st.resultsPerPage,
            resultsMaxPage: st.resultsMaxPage,
            resultsPage: st.resultsPage,
            checkedResultsIdx: st.checkedResultsIdx.filter(function (i) {
                  return i !== idx;
                })
          };
  } else {
    return {
            label: st.label,
            allTypes: st.allTypes,
            typ: st.typ,
            patternStr: st.patternStr,
            patternErr: st.patternErr,
            results: st.results,
            resultsPerPage: st.resultsPerPage,
            resultsMaxPage: st.resultsMaxPage,
            resultsPage: st.resultsPage,
            checkedResultsIdx: st.checkedResultsIdx.concat([idx])
          };
  }
}

function MM_cmp_search_asrt(props) {
  var onResultsSelected = props.onResultsSelected;
  var onCanceled = props.onCanceled;
  var onTypChange = props.onTypChange;
  var initialTyp = props.initialTyp;
  var wrkCtx = props.wrkCtx;
  var preCtxData = props.preCtxData;
  var modalRef = props.modalRef;
  var match = React.useState(function () {
        return makeInitialState(preCtxData.frms, initialTyp);
      });
  var setState = match[1];
  var state = match[0];
  var rootPaperRef = React.useRef(null);
  var match$1 = MM_use_highlight_color.useHighlightColor();
  var highlightColor = match$1[0];
  React.useEffect((function () {
          var rootPaperRef$1 = rootPaperRef.current;
          if (!(rootPaperRef$1 == null)) {
            var parentNode = rootPaperRef$1.parentNode;
            if (!(parentNode == null)) {
              parentNode.scrollTop = 0;
            }
            
          }
          
        }), [state.resultsPage]);
  var actResultsRetrieved = function (results) {
    setState(function (__x) {
          return setResults(__x, results);
        });
  };
  var makeActTerminate = function (modalId) {
    return function () {
      MM_wrk_client.terminateWorker();
      Expln_React_Modal.closeModal(modalRef, modalId);
    };
  };
  var actSearch = function () {
    onTypChange(state.typ);
    var patternStr = state.patternStr.trim();
    var msg = MM_wrk_pattern_search.parsePattern(patternStr, 2, wrkCtx);
    if (msg.TAG === "Ok") {
      setState(function (__x) {
            return setPatternErr(__x, undefined);
          });
      Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                  return MM_react_common.rndProgress("Searching", 0, undefined);
                })), (function (modalId) {
              Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                      return MM_react_common.rndProgress("Searching", 0, makeActTerminate(modalId));
                    }));
              return Expln_utils_promise.promiseMap(MM_wrk_search_asrt.searchAssertions(preCtxData.settingsV.ver, preCtxData.settingsV.val, preCtxData.ctxV.ver, preCtxData.ctxV.val.min, undefined, state.typ, state.label.trim(), patternStr, 2, undefined, undefined, undefined, (function (pct) {
                                Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                                        return MM_react_common.rndProgress("Searching", pct, makeActTerminate(modalId));
                                      }));
                              })), (function (foundLabels) {
                            Expln_React_Modal.closeModal(modalRef, modalId);
                            actResultsRetrieved(foundLabels);
                          }));
            }));
      return ;
    }
    var msg$1 = msg._0;
    setState(function (__x) {
          return setPatternErr(__x, msg$1);
        });
    actResultsRetrieved([]);
  };
  var actChooseSelected = function () {
    var results = state.results;
    if (results !== undefined) {
      return onResultsSelected(results.filter(function (param, i) {
                        return state.checkedResultsIdx.includes(i);
                      }).map(function (param) {
                      return param[0];
                    }));
    }
    
  };
  var actLabelChange = function (str) {
    setState(function (__x) {
          return setLabel(__x, str);
        });
  };
  var actTypeChange = function (newTypeStr) {
    setState(function (__x) {
          return setType(__x, MM_context.ctxSymToIntExn(wrkCtx, newTypeStr));
        });
  };
  var actPatternChange = function (newPatternStr) {
    setState(function (__x) {
          return setPatternStr(__x, newPatternStr);
        });
  };
  var rndError = function (msgOpt) {
    if (msgOpt !== undefined) {
      return React.createElement("pre", {
                  style: {
                    color: "red"
                  }
                }, msgOpt);
    } else {
      return null;
    }
  };
  var rndPattern = function () {
    return React.createElement(TextField, {
                value: state.patternStr,
                label: "Pattern",
                size: "small",
                style: {
                  width: "300px"
                },
                onChange: Expln_React_common.evt2str(actPatternChange),
                onKeyDown: MM_react_common.kbrdHnd2(MM_react_common.kbrdClbkMake(MM_react_common.keyEnter, undefined, undefined, undefined, actSearch), MM_react_common.kbrdClbkMake(MM_react_common.keyEsc, undefined, undefined, undefined, onCanceled)),
                autoFocus: true
              });
  };
  var rndLabel = function () {
    return React.createElement(TextField, {
                value: state.label,
                label: "Label",
                size: "small",
                style: {
                  width: "100px"
                },
                onChange: Expln_React_common.evt2str(actLabelChange),
                onKeyDown: MM_react_common.kbrdHnd2(MM_react_common.kbrdClbkMake(MM_react_common.keyEnter, undefined, undefined, undefined, actSearch), MM_react_common.kbrdClbkMake(MM_react_common.keyEsc, undefined, undefined, undefined, onCanceled))
              });
  };
  var rndTyp = function () {
    return React.createElement(FormControl, {
                size: "small",
                children: Caml_option.some(null)
              }, React.createElement(InputLabel, {
                    id: "asrt-type-select-label",
                    children: "Type"
                  }), React.createElement(Select, {
                    labelId: "asrt-type-select-label",
                    label: "Type",
                    value: MM_context.ctxIntToSymExn(wrkCtx, state.typ),
                    onChange: Expln_React_common.evt2str(actTypeChange),
                    children: Caml_option.some(state.allTypes.map(function (typI) {
                              var typStr = MM_context.ctxIntToSymExn(wrkCtx, typI);
                              return JsxPPXReactSupportU.createElementWithKey(typStr, MenuItem, {
                                          value: typStr,
                                          children: Caml_option.some(typStr)
                                        });
                            }))
                  }));
  };
  var rndFilters = function () {
    return React.createElement(Expln_React_Column.make, {
                children: Caml_option.some(null)
              }, React.createElement(Expln_React_Row.make, {
                    children: Caml_option.some(null)
                  }, rndLabel(), rndTyp(), rndPattern(), React.createElement(Button, {
                        onClick: (function (param) {
                            actSearch();
                          }),
                        variant: "contained",
                        color: "grey",
                        children: "Search"
                      }), React.createElement(Button, {
                        onClick: (function (param) {
                            onCanceled();
                          }),
                        children: "Cancel"
                      })), rndError(state.patternErr));
  };
  var rndPagination = function (totalNumOfResults) {
    if (state.resultsPerPage < totalNumOfResults) {
      return React.createElement(Pagination, {
                  count: state.resultsMaxPage,
                  page: state.resultsPage,
                  onChange: (function (param, newPage) {
                      setState(function (__x) {
                            return setPage(__x, newPage);
                          });
                    })
                });
    } else {
      return null;
    }
  };
  var rndResultButtons = function () {
    return React.createElement(Expln_React_Row.make, {
                children: Caml_option.some(null)
              }, React.createElement(Button, {
                    onClick: (function (param) {
                        actChooseSelected();
                      }),
                    variant: "contained",
                    disabled: state.checkedResultsIdx.length === 0,
                    children: "Choose selected"
                  }), React.createElement(Button, {
                    onClick: (function (param) {
                        onCanceled();
                      }),
                    children: "Cancel"
                  }));
  };
  var addAsrtByLabel = function (label) {
    onResultsSelected([label]);
    return Promise.resolve({
                TAG: "Ok",
                _0: undefined
              });
  };
  var rndFrameSummary = function (param) {
    var label = param[0];
    var frame = MM_context.getFrame(preCtxData.ctxV.val.min, label);
    if (frame !== undefined) {
      return JsxPPXReactSupportU.createElementWithKey(String(frame.ord) + "-" + label, MM_cmp_pe_frame_summary.make, {
                  modalRef: modalRef,
                  typeColors: preCtxData.typeColors,
                  editStmtsByLeftClick: preCtxData.settingsV.val.editStmtsByLeftClick,
                  typeOrderInDisj: preCtxData.typeOrderInDisj,
                  settings: preCtxData.settingsV.val,
                  preCtx: preCtxData.ctxV.val.min,
                  symColors: preCtxData.symColors,
                  syntaxTypes: preCtxData.syntaxTypes,
                  frms: preCtxData.frms,
                  parenCnt: preCtxData.parenCnt,
                  frame: frame,
                  order: undefined,
                  matchedIdxs: param[1],
                  highlightColor: highlightColor,
                  openFrameExplorer: undefined,
                  openExplorer: undefined,
                  addAsrtByLabel: addAsrtByLabel
                });
    } else {
      return null;
    }
  };
  var rndResults = function () {
    var results = state.results;
    if (results === undefined) {
      return null;
    }
    var labelsToRender = [];
    var minI = Math.imul(state.resultsPage - 1 | 0, state.resultsPerPage);
    var maxI = Math.min((minI + state.resultsPerPage | 0) - 1 | 0, results.length - 1 | 0);
    for(var i = minI; i <= maxI; ++i){
      labelsToRender.push(results[i]);
    }
    var totalNumOfResults = results.length;
    return React.createElement(Expln_React_Column.make, {
                children: Caml_option.some(null)
              }, rndResultButtons(), rndPagination(totalNumOfResults), labelsToRender.map(function (label, i) {
                    var resIdx = minI + i | 0;
                    return React.createElement("table", {
                                key: String(resIdx)
                              }, React.createElement("tbody", undefined, React.createElement("tr", undefined, React.createElement("td", undefined, React.createElement(Checkbox, {
                                                checked: state.checkedResultsIdx.includes(resIdx),
                                                onChange: (function (param) {
                                                    setState(function (__x) {
                                                          return toggleResultChecked(__x, resIdx);
                                                        });
                                                  })
                                              })), React.createElement("td", undefined, rndFrameSummary(label)))));
                  }), rndPagination(totalNumOfResults), rndResultButtons());
  };
  return React.createElement(Paper, {
              ref: Caml_option.some(rootPaperRef),
              style: {
                padding: "10px"
              },
              children: Caml_option.some(React.createElement(Expln_React_Column.make, {
                        spacing: 1,
                        children: Caml_option.some(null)
                      }, rndFilters(), rndResults()))
            });
}

var make = MM_cmp_search_asrt;

exports.makeInitialState = makeInitialState;
exports.setResults = setResults;
exports.setPage = setPage;
exports.setLabel = setLabel;
exports.setType = setType;
exports.setPatternStr = setPatternStr;
exports.setPatternErr = setPatternErr;
exports.toggleResultChecked = toggleResultChecked;
exports.make = make;
/* react Not a pure module */
